import { render } from "./UpdateDepositLimitVIew.vue?vue&type=template&id=66177270&scoped=true"
import script from "./UpdateDepositLimitVIew.vue?vue&type=script&lang=js"
export * from "./UpdateDepositLimitVIew.vue?vue&type=script&lang=js"

import "./UpdateDepositLimitVIew.vue?vue&type=style&index=0&id=66177270&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66177270"]])

export default __exports__